import 'css-chunksrc/client/common/layout/version/styles.scss';export default {
  "version": "_version_q3lji_1"
};